import { render, staticRenderFns } from "./HowToMessagerie.vue?vue&type=template&id=593addfd&"
import script from "./HowToMessagerie.js?vue&type=script&lang=js&"
export * from "./HowToMessagerie.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports